import { ImageType } from "@/types/baseTypes.ts";
import styles from "./FormBox.module.scss";
import Split from "@/components/_primitives/Split/Split.tsx";
import { MediaItem } from "@/components/MediaItem/MediaItem.tsx";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG";

type FormBoxProps = {
  image: ImageType | false;
  headline: string;
  text: string;
  className: string;
};

export default function FormBox({
  image,
  headline,
  text,
  className,
}: FormBoxProps) {
  const isSVG = image && image.mime_type === "image/svg+xml";

  const imageJsx = image ? (
    isSVG ? (
      <CustomSVG
        src={image.url}
        wrapper="div"
        className={`${styles.image} ${styles.svg}`}
        width={"100%"}
        height={"100%"}
        role="img"
        aria-label={image.alt || image.title}
      />
    ) : (
      <MediaItem
        className={styles.image}
        image_desktop={image}
        sizes={"200px"}
      />
    )
  ) : (
    <></>
  );

  const textContentJsx = (
    <>
      <h3 className={styles["headline"]}>{headline}</h3>
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </>
  );

  return (
    <div className={className}>
      <div className={`${styles["form-box"]}`}>
        {image ? (
          <Split
            first={imageJsx}
            second={textContentJsx}
            direction={"row-reverse"}
            extraParentClasses={styles.content}
            firstClassName={styles["image-column"]}
            secondClassName={styles["text-column"]}
          />
        ) : (
          <div className={styles.content}>
            <div className={styles["text-column"]}>{textContentJsx}</div>
          </div>
        )}
      </div>
    </div>
  );
}
